var map = {
	"./CompactHeaderExtensions": 68959,
	"./CompactHeaderExtensions.ts": 68959,
	"./FooterExtensions": 3336,
	"./FooterExtensions.ts": 3336,
	"./HeaderExtensions": 32446,
	"./HeaderExtensions.ts": 32446,
	"./HomePageExtensions": 70731,
	"./HomePageExtensions.ts": 70731,
	"./OrderApprovalDetailsPageExtensions": 19191,
	"./OrderApprovalDetailsPageExtensions.ts": 19191,
	"./SavedOrderDetailsPageExtensions": 17545,
	"./SavedOrderDetailsPageExtensions.ts": 17545
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 314;